/* Capture Bleu : succès uniquement après stockage attribué ET acceptation Klaviyo. */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    var forms = Array.from(root.querySelectorAll('[data-wlblue-form]'));
    var busy = false;
    var savedEmails = new Set();
    var qs = new URLSearchParams(window.location.search);
    var utm = {};
    ['source', 'medium', 'campaign', 'content', 'term'].forEach(function (key) {
      utm['utm_' + key] = qs.get('utm_' + key) || null;
    });
    var landing = window.location.pathname + window.location.search;
    var storageKey = 'omads_waitlist_bleu_attribution';
    try {
      if (utm.utm_source) sessionStorage.setItem(storageKey, JSON.stringify({utm: utm, landing: landing}));
      else {
        var saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        if (saved && saved.utm) { utm = saved.utm; landing = saved.landing || landing; }
      }
    } catch (_) { /* La capture reste possible si le navigateur bloque le stockage. */ }
    function channel() {
      if (utm.utm_source) return utm.utm_source.toLowerCase();
      var ref = document.referrer || '';
      if (/facebook|instagram|fb\./i.test(ref)) return 'meta';
      if (/tiktok/i.test(ref)) return 'tiktok';
      if (/google/i.test(ref)) return 'google';
      return 'site';
    }
    async function post(url, headers, payload) {
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 20000);
      try {
        return await fetch(url, {method: 'POST', headers: headers, body: JSON.stringify(payload), signal: controller.signal});
      } finally { clearTimeout(timer); }
    }
    async function capture(email) {
      if (savedEmails.has(email)) return;
      var publicKey = 'sb_publishable_QthosKqCipG4xedUnfPoaw_ooG-8YjW';
      var response = await post('https://eluljtthflzzsmrcoqlg.supabase.co/rest/v1/waitlist_subscriptions', {
        'Content-Type': 'application/json', apikey: publicKey, Authorization: 'Bearer ' + publicKey, Prefer: 'return=minimal'
      }, Object.assign({}, utm, {
        waitlist_name: 'shampoing-bleu', email: email,
        source: 'lp-liste-attente-shampoing-bleu', klaviyo_list_id: root.dataset.list,
        channel: channel(), page_url: landing, language: root.dataset.language.toUpperCase(),
        referrer: document.referrer || null, user_agent: navigator.userAgent || null
      }));
      if (!response.ok) {
        // Une contrainte UNIQUE peut confirmer une inscription déjà enregistrée.
        var error = await response.json().catch(function () { return {}; });
        if (response.status !== 409 || error.code !== '23505') throw new Error('waitlist_capture_failed');
      }
      savedEmails.add(email);
    }
    async function subscribe(email) {
      var response = await post('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(root.dataset.company), {
        accept: 'application/json', 'content-type': 'application/json', revision: '2024-10-15'
      }, {data: {
        type: 'subscription', attributes: {
          custom_source: 'LP Liste attente Shampoing bleu',
          profile: {data: {type: 'profile', attributes: {email: email, properties: {
            waitlist_source: 'shampoing-bleu', waitlist_bleu: true,
            signup_date: new Date().toISOString(), wl_channel: channel(),
            wl_utm_source: utm.utm_source || 'organique', wl_utm_medium: utm.utm_medium || '',
            wl_utm_campaign: utm.utm_campaign || '', wl_utm_content: utm.utm_content || '',
            wl_language: root.dataset.language,
            // `lang` = la seule propriété que lisent les segments de langue (10/10/2026).
            lang: (root.dataset.language || 'fr').slice(0, 2).toUpperCase()
          }}}}
        }, relationships: {list: {data: {type: 'list', id: root.dataset.list}}}
      }});
      if (!response.ok) throw new Error('waitlist_subscription_failed');
    }
    forms.forEach(function (form) {
      var input = form.querySelector('input[type="email"]');
      var button = form.querySelector('button');
      var feedback = form.querySelector('[data-wlblue-feedback]');
      var original = button.textContent;
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (busy) return;
        input.value = input.value.trim().toLowerCase();
        if (!form.reportValidity()) return;
        if (!root.dataset.list || !root.dataset.company) { feedback.textContent = form.dataset.error; return; }
        var email = input.value;
        busy = true;
        forms.forEach(function (f) { f.querySelector('button').disabled = true; f.querySelector('input').disabled = true; });
        button.textContent = form.dataset.loading;
        feedback.textContent = '';
        try {
          await capture(email);
          await subscribe(email);
          forms.forEach(function (f) {
            f.querySelector('[data-wlblue-feedback]').textContent = f.dataset.success;
            f.querySelector('button').textContent = f.dataset.done;
            f.querySelector('input').disabled = true;
          });
        } catch (error) {
          feedback.textContent = form.dataset.error;
          button.textContent = original;
          forms.forEach(function (f) { f.querySelector('button').disabled = false; f.querySelector('input').disabled = false; });
          busy = false;
          // Pas d'email dans le journal de diagnostic du navigateur.
          console.error('[waitlist-bleu] Échec de capture ou de consentement', error.name);
        }
      });
    });
  }
  function all() { document.querySelectorAll('[data-wlblue]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  document.addEventListener('shopify:section:load', all);
})();
